/**
 * Mismas URLs que sumer-landing:
 * `front/sumer-landing/src/modules/landing/components/download-app/download-app.data.ts`
 */
export const MOBILE_APP_STORE_LINKS = {
  android: {
    url: "https://play.google.com/store/apps/details?id=com.sumerlabs.sumer_app",
  },
  ios: {
    url: "https://apps.apple.com/us/app/sumer-crea-tu-tienda-online/id1583799355",
  },
} as const;
